/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Das28EditionFormComponent from "parog-web/components/abstract/das28-edition-form";

import dayjs from "dayjs";
import baseEditionFormStyles from "parog-web/components/das28/base-edition-form/index.module.css";
import { computeDas28Crp } from "parog-web/components/das28/utils/compute-das28";
import { computeCrpOrVsDas28Activity } from "parog-web/components/das28/utils/compute-das28-activity";
import getLastBioExamInfos from "parog-web/components/das28/utils/get-last-bio-exam-infos";
import Das28CrpComputedJournalEvent from "parog-web/models/das28-crp-computed-journal-event";

export default class Das28CrpEditionFormComponent extends Das28EditionFormComponent {
  static forcDisplayName = "Calculer le DAS 28 CRP";
  static fullComponentId = "das28/das28-crp-edition-form";
  static journalEventClass = Das28CrpComputedJournalEvent;

  currentComputeDas28Function = computeDas28Crp;
  currentComputeDAS28Activity = computeCrpOrVsDas28Activity;

  specificDas28Properties = ["crp", "comments"];
  baseEditionFormStyles = baseEditionFormStyles;

  journalEventProperties = [
    ...this.specificDas28Properties,
    ...this.standardJournalEventProperties,
    ...this.sharedDas28Properties
  ];

  get lastBioExamsInfos() {
    //CRP
    const crpCode = "LOINC-1988-5";
    //get only bioExamsJE with crp
    return getLastBioExamInfos(this.patient, "crp", crpCode);
  }

  get lastCrpDate() {
    if (
      this.lastBioExamsInfos.crp != undefined &&
      this.changeset.get("crp") == this.lastBioExamsInfos.crp
    ) {
      return dayjs(this.lastBioExamsInfos.occurredAt).format(
        "[Dernière mesure le] DD/MM/YYYY"
      );
    }
    return "";
  }

  retrieveModel() {
    const model = super.retrieveModel();
    if (this.isNewMode) {
      model.crp = this.lastBioExamsInfos?.crp;
    }
    return model;
  }
}
